module.exports = __webpack_public_path__ + "img/layout_right_4.185054b8.png";